export default __webpack_public_path__ + "static/media/gallery - felix_01.d3b43909.jpg";